// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 0px) and (max-width: 767px) {
  .aboutus_banner_container {
    padding: 5px 20px 10px 20px;
  }
  .aboutus_banner_link_home {
    display: none;
  }
  .aboutus_banner_link_about {
    display: none;
  }
  .aboutus_banner_link_arrow {
    display: none;
  }
  .aboutus_banner_content {
    font-size: 20px;
  }
  .aboutus_banner_content_ta {
    font-size: 18px;
  }
  .our_mission_container {
    display: block;
    padding: 20px 20px 10px 20px;
  }
  .our_mission_left {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .our_mission_right {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
  }
  .meet_the_team_container {
    padding: 20px 20px 10px 20px;
  }
  .meet_the_team_head {
    display: block;
  }
  .meet_the_team_heading {
    width: 100%;
    font-size: 30px;
  }
  .meet_the_team_right_content {
    width: 100%;
  }
  .team_members_image,
  .medical_expert_image {
    display: flex;
    overflow: scroll;
  }
  .team_members_image::-webkit-scrollbar {
    display: none;
  }
  .medical_expert_image::-webkit-scrollbar {
    display: none;
  }
  .team_member_image {
    height: 160px;
    width: 160px;
  }
  .team_member_description {
    display: none;
  }
  .medical_expert_heading {
    margin: 25px 0;
  }
  .policies_container {
    padding: 5px 20px 10px 20px;
    overflow: hidden;
    margin-bottom: 0;
    gap: 20px;
  }
  .ifcn_image_desktop,
  .public_spirited_image_desktop {
    display: none;
    margin: auto;
  }
  .ifcn_image_mobile {
    display: grid;
    place-items: center;
  }
  .public_spirited_image_mobile {
    display: flex;
    flex-direction: column;
    place-items: center;
    margin-bottom: 20px;
  }
  .what_we_check_text {
    font-size: 13px;
  }
  .what_we_check_content {
    font-size: 8px;
  }
  .ifcn_image {
    width: 200px;
  }
  .icnf_certificate {
    display: block;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .policies_head {
    display: block;
    padding: 5px 20px 10px 20px;
    margin-top: 20px !important;
  }
  .ifcn_container {
    width: 100%;
  }
  .fact_check_description_one {
    margin-left: 0px;
    font-size: 11px;
    line-height: 1.1;
    padding: 3px 5px 3px 0;
    max-height: fit-content;
  }
  .fact_check_heading_mob {
    display: block;
    font-size: 4vw;
    font-family: "lato";
    margin-bottom: 5px;
    font-weight: 800;
    margin-left: 35px;
  }
  .fact_check_heading_dt {
    display: none;
  }

  .policies_heading {
    font-size: 24px;
    margin: 20px 0px 0px 0px;
  }

  .policies_button_div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: 100%;
  }
  .policies_button {
    width: 90%;
    border-radius: 12px;
  }
  .fight_fake_news_desktop {
    display: none;
  }
  .fight_fake_news_mod {
    display: block;
    margin: 25px 0;
  }
  .fact_check_div {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .fact_check_div_mob {
    align-items: center;
    width: 100%;
    justify-content: start;
  }
  .fact_check_divs {
    width: 100%;
    flex-direction: column;
  }
  .fact_check_image {
    width: 75px;
    height: 75px;
  }
  .what_we_check_div {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    gap: 20px;
    place-items: center;
  }
  .what_we_check_items {
    width: 95%;
    align-items: center;
    justify-content: center;
  }
  .what_we_check_img {
    padding-top: 10px;
  }
  .share_circle {
    display: none;
  }
  .fact_check_items_container {
    display: block;
    width: 100%;
    gap: 25px;
  }
  .fact_check_item {
    align-items: center;
    justify-content: center;
    margin: 25px 0;
    gap: 0;
  }
  .fact_check_image_one {
    margin-right: 4px;
  }
  .stay_connect_mobile {
    display: block;
    position: relative;
    margin-top: 50px;
    width: 120%;
    background: linear-gradient(#111a42 10%, #f49d36 280%);
    color: white;
    padding: 20px 0;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
  }
  .stay_connect_items {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }
  .stay_connect_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 15px;
  }
  .stay_connect_mobile_heading {
    text-align: center;
    margin: 40px 0;
  }
  .funding_container {
    display: block;
    margin: 0px;
  }
  .funding_container_left {
    width: 100%;
  }
  .funding_container_right {
    width: 120%;
    border-radius: 0;
    padding: 40px 70px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 0;
    margin-left: 0px;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
  }
  .award_list_div {
    display: block;
  }
  .award_list_one {
    width: 100%;
  }
  .award_list_two {
    width: 100%;
  }
  .award_list_one_description,
  .award_list_one_content,
  .award_list_one_link {
    display: none;
  }
  .award_list_container {
    padding: 5px 20px 10px 20px;
    margin-top: -10px;
  }
  .award_list_image {
    width: 120px;
  }
  .become_a_member_button {
    border-radius: 12px;
    border: 1px solid #0065cd;
  }
  .icnf_button {
    width: 90%;
    border-radius: 12px;
  }
  .fight_fake_news_container {
    display: none;
  }
  .fight_fake_news_container_mob {
    background-color: #140f2d;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 40px;
    padding-right: 30px;
    padding-left: 30px;
    border-radius: 0;
    height: auto;
    margin-top: 20px;
    display: block;
  }

  .fight_fake_news_head {
    font-size: 3vw;
    color: white;
  }
  .figh_fake_news_note {
    font-size: 2vw;
    color: white;
  }
  .figh_fake_news_button {
    font-size: 4vw;
  }
  .fight_fake_news_hash_val {
    font-size: 8vw;
    margin-top: 10px;
  }
  .fight_fake_news_hash {
    font-size: 18vw;
    padding-bottom: 14px;
  }
  .figh_fake_news_button_mob {
    height: 35px;
    width: 50%;
    border-radius: 8px;
    background-color: #0065cd;
    color: white;
    border: none;
  }
  .figh_fake_news_note_mob {
    font-size: 2.5vw;
    width: 45%;
    font-family: Lato;
    text-align: justify;
    margin: 0;
    padding: 0;
    color: white;
  }
  .figh_fake_news_input_mob {
    width: 100%;
    height: 35px;
    background: white;
    border: none;
    border-radius: 8px;
    text-align: left;
    padding-left: 10px;
    margin: 10px 0 15px;
  }
  .funding_container_right {
    display: none;
  }
  .medical_expert_container {
    display: none;
  }
  .award_list_container {
    display: none;
  }
  .award_list_container_mob {
    display: block;
    background: linear-gradient(115deg, #111a42 10%, #f49d36 280%);
    color: white;
    margin: 0;
    margin-top: -10px;
    padding: 5px 20px 10px 20px;
  }
  .award_list_two_mob {
    position: relative;
    width: 80%;
    margin: 15px 0;
    box-shadow: 1px 1px 1px white;
    overflow: hidden;
    border-radius: 10px;
  }
  .award_list_star_note {
    position: absolute;
    width: 80%;
    bottom: 15px;
    font-weight: 500;
    right: 0;
    background-color: #d2d1d7;
  }
  .award_list_star_note {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: black;
    height: 60px;
  }
  .awardlist_star_description {
    margin: 0;
    padding: 8px 0px;
    font-weight: 500;
    font-size: 2vh;
    line-height: 1.2;
  }
  .awardlist_star_icon {
    width: 18%;
    margin: 0 10px;
  }
  .award_list_two_img {
    filter: brightness(65%);
    border-radius: 1px;
    border: 1px solid white;
    overflow: hidden;
    object-fit: contain;
    width: 100%;
    height: auto;
  }
  .award_list_two_mob_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .hide_about_page_in_mobile {
    display: none !important;
  }

  .team_members_details {
    background-color: transparent;
    border-color: #ffb037;
    border-radius: 10px;
    display: flex;
    margin: 2vh;
  }
  .team_member_image {
    display: flex;
  }
  .team_members_details .team_member_image {
    flex-direction: column-reverse;
  }
  .team_members_details .team_member_name {
    width: 100%;
  }
  .team_members_details .member_description {
    margin-top: 20px;
  }
  .member_description {
    width: 100%;
  }
  .policy-container h1 {
    font-size: 1.2em;
  }

  .policy-container p,
  .policy-container li {
    font-size: 0.9em;
  }
  .corrections-policy {
    padding: 10px;
  }

  .corrections-policy h1 {
    font-size: 1.2em;
  }

  .corrections-policy p {
    font-size: 0.8em;
  }

  .corrections-policy li {
    font-size: 0.8em;
  }
  .ifcn_main_container {
    width: 100%;
  }
  .fact_check_container {
    gap: 0px;
  }
  .ifcn_certificates_notes{
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_767/screen_767_aboutus.css"],"names":[],"mappings":"AAAA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;EACzB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;;IAEE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;EACX;EACA;;IAEE,aAAa;IACb,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;EACb;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,cAAc;EAChB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,WAAW;IACX,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,MAAM;EACR;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,sDAAsD;IACtD,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,kCAAkC;IAClC,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;EAC7B;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;;;IAGE,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,8DAA8D;IAC9D,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,2BAA2B;EAC7B;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,yBAAyB;EAC3B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,YAAY;EACd;EACA;IACE,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,6BAA6B;IAC7B,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,8BAA8B;EAChC;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":["@media only screen and (min-width: 0px) and (max-width: 767px) {\r\n  .aboutus_banner_container {\r\n    padding: 5px 20px 10px 20px;\r\n  }\r\n  .aboutus_banner_link_home {\r\n    display: none;\r\n  }\r\n  .aboutus_banner_link_about {\r\n    display: none;\r\n  }\r\n  .aboutus_banner_link_arrow {\r\n    display: none;\r\n  }\r\n  .aboutus_banner_content {\r\n    font-size: 20px;\r\n  }\r\n  .aboutus_banner_content_ta {\r\n    font-size: 18px;\r\n  }\r\n  .our_mission_container {\r\n    display: block;\r\n    padding: 20px 20px 10px 20px;\r\n  }\r\n  .our_mission_left {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .our_mission_right {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: start;\r\n    justify-content: center;\r\n  }\r\n  .meet_the_team_container {\r\n    padding: 20px 20px 10px 20px;\r\n  }\r\n  .meet_the_team_head {\r\n    display: block;\r\n  }\r\n  .meet_the_team_heading {\r\n    width: 100%;\r\n    font-size: 30px;\r\n  }\r\n  .meet_the_team_right_content {\r\n    width: 100%;\r\n  }\r\n  .team_members_image,\r\n  .medical_expert_image {\r\n    display: flex;\r\n    overflow: scroll;\r\n  }\r\n  .team_members_image::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n  .medical_expert_image::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n  .team_member_image {\r\n    height: 160px;\r\n    width: 160px;\r\n  }\r\n  .team_member_description {\r\n    display: none;\r\n  }\r\n  .medical_expert_heading {\r\n    margin: 25px 0;\r\n  }\r\n  .policies_container {\r\n    padding: 5px 20px 10px 20px;\r\n    overflow: hidden;\r\n    margin-bottom: 0;\r\n    gap: 20px;\r\n  }\r\n  .ifcn_image_desktop,\r\n  .public_spirited_image_desktop {\r\n    display: none;\r\n    margin: auto;\r\n  }\r\n  .ifcn_image_mobile {\r\n    display: grid;\r\n    place-items: center;\r\n  }\r\n  .public_spirited_image_mobile {\r\n    display: flex;\r\n    flex-direction: column;\r\n    place-items: center;\r\n    margin-bottom: 20px;\r\n  }\r\n  .what_we_check_text {\r\n    font-size: 13px;\r\n  }\r\n  .what_we_check_content {\r\n    font-size: 8px;\r\n  }\r\n  .ifcn_image {\r\n    width: 200px;\r\n  }\r\n  .icnf_certificate {\r\n    display: block;\r\n    margin-bottom: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .policies_head {\r\n    display: block;\r\n    padding: 5px 20px 10px 20px;\r\n    margin-top: 20px !important;\r\n  }\r\n  .ifcn_container {\r\n    width: 100%;\r\n  }\r\n  .fact_check_description_one {\r\n    margin-left: 0px;\r\n    font-size: 11px;\r\n    line-height: 1.1;\r\n    padding: 3px 5px 3px 0;\r\n    max-height: fit-content;\r\n  }\r\n  .fact_check_heading_mob {\r\n    display: block;\r\n    font-size: 4vw;\r\n    font-family: \"lato\";\r\n    margin-bottom: 5px;\r\n    font-weight: 800;\r\n    margin-left: 35px;\r\n  }\r\n  .fact_check_heading_dt {\r\n    display: none;\r\n  }\r\n\r\n  .policies_heading {\r\n    font-size: 24px;\r\n    margin: 20px 0px 0px 0px;\r\n  }\r\n\r\n  .policies_button_div {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 20px;\r\n    width: 100%;\r\n  }\r\n  .policies_button {\r\n    width: 90%;\r\n    border-radius: 12px;\r\n  }\r\n  .fight_fake_news_desktop {\r\n    display: none;\r\n  }\r\n  .fight_fake_news_mod {\r\n    display: block;\r\n    margin: 25px 0;\r\n  }\r\n  .fact_check_div {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n  }\r\n  .fact_check_div_mob {\r\n    align-items: center;\r\n    width: 100%;\r\n    justify-content: start;\r\n  }\r\n  .fact_check_divs {\r\n    width: 100%;\r\n    flex-direction: column;\r\n  }\r\n  .fact_check_image {\r\n    width: 75px;\r\n    height: 75px;\r\n  }\r\n  .what_we_check_div {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: 1fr;\r\n    gap: 20px;\r\n    place-items: center;\r\n  }\r\n  .what_we_check_items {\r\n    width: 95%;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .what_we_check_img {\r\n    padding-top: 10px;\r\n  }\r\n  .share_circle {\r\n    display: none;\r\n  }\r\n  .fact_check_items_container {\r\n    display: block;\r\n    width: 100%;\r\n    gap: 25px;\r\n  }\r\n  .fact_check_item {\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin: 25px 0;\r\n    gap: 0;\r\n  }\r\n  .fact_check_image_one {\r\n    margin-right: 4px;\r\n  }\r\n  .stay_connect_mobile {\r\n    display: block;\r\n    position: relative;\r\n    margin-top: 50px;\r\n    width: 120%;\r\n    background: linear-gradient(#111a42 10%, #f49d36 280%);\r\n    color: white;\r\n    padding: 20px 0;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n  }\r\n  .stay_connect_items {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n    grid-template-rows: 1fr 1fr;\r\n  }\r\n  .stay_connect_item {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 15px;\r\n  }\r\n  .stay_connect_mobile_heading {\r\n    text-align: center;\r\n    margin: 40px 0;\r\n  }\r\n  .funding_container {\r\n    display: block;\r\n    margin: 0px;\r\n  }\r\n  .funding_container_left {\r\n    width: 100%;\r\n  }\r\n  .funding_container_right {\r\n    width: 120%;\r\n    border-radius: 0;\r\n    padding: 40px 70px;\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    margin-bottom: 0;\r\n    margin-left: 0px;\r\n    position: relative;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n  }\r\n  .award_list_div {\r\n    display: block;\r\n  }\r\n  .award_list_one {\r\n    width: 100%;\r\n  }\r\n  .award_list_two {\r\n    width: 100%;\r\n  }\r\n  .award_list_one_description,\r\n  .award_list_one_content,\r\n  .award_list_one_link {\r\n    display: none;\r\n  }\r\n  .award_list_container {\r\n    padding: 5px 20px 10px 20px;\r\n    margin-top: -10px;\r\n  }\r\n  .award_list_image {\r\n    width: 120px;\r\n  }\r\n  .become_a_member_button {\r\n    border-radius: 12px;\r\n    border: 1px solid #0065cd;\r\n  }\r\n  .icnf_button {\r\n    width: 90%;\r\n    border-radius: 12px;\r\n  }\r\n  .fight_fake_news_container {\r\n    display: none;\r\n  }\r\n  .fight_fake_news_container_mob {\r\n    background-color: #140f2d;\r\n    width: 100%;\r\n    padding-top: 10px;\r\n    padding-bottom: 40px;\r\n    padding-right: 30px;\r\n    padding-left: 30px;\r\n    border-radius: 0;\r\n    height: auto;\r\n    margin-top: 20px;\r\n    display: block;\r\n  }\r\n\r\n  .fight_fake_news_head {\r\n    font-size: 3vw;\r\n    color: white;\r\n  }\r\n  .figh_fake_news_note {\r\n    font-size: 2vw;\r\n    color: white;\r\n  }\r\n  .figh_fake_news_button {\r\n    font-size: 4vw;\r\n  }\r\n  .fight_fake_news_hash_val {\r\n    font-size: 8vw;\r\n    margin-top: 10px;\r\n  }\r\n  .fight_fake_news_hash {\r\n    font-size: 18vw;\r\n    padding-bottom: 14px;\r\n  }\r\n  .figh_fake_news_button_mob {\r\n    height: 35px;\r\n    width: 50%;\r\n    border-radius: 8px;\r\n    background-color: #0065cd;\r\n    color: white;\r\n    border: none;\r\n  }\r\n  .figh_fake_news_note_mob {\r\n    font-size: 2.5vw;\r\n    width: 45%;\r\n    font-family: Lato;\r\n    text-align: justify;\r\n    margin: 0;\r\n    padding: 0;\r\n    color: white;\r\n  }\r\n  .figh_fake_news_input_mob {\r\n    width: 100%;\r\n    height: 35px;\r\n    background: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    text-align: left;\r\n    padding-left: 10px;\r\n    margin: 10px 0 15px;\r\n  }\r\n  .funding_container_right {\r\n    display: none;\r\n  }\r\n  .medical_expert_container {\r\n    display: none;\r\n  }\r\n  .award_list_container {\r\n    display: none;\r\n  }\r\n  .award_list_container_mob {\r\n    display: block;\r\n    background: linear-gradient(115deg, #111a42 10%, #f49d36 280%);\r\n    color: white;\r\n    margin: 0;\r\n    margin-top: -10px;\r\n    padding: 5px 20px 10px 20px;\r\n  }\r\n  .award_list_two_mob {\r\n    position: relative;\r\n    width: 80%;\r\n    margin: 15px 0;\r\n    box-shadow: 1px 1px 1px white;\r\n    overflow: hidden;\r\n    border-radius: 10px;\r\n  }\r\n  .award_list_star_note {\r\n    position: absolute;\r\n    width: 80%;\r\n    bottom: 15px;\r\n    font-weight: 500;\r\n    right: 0;\r\n    background-color: #d2d1d7;\r\n  }\r\n  .award_list_star_note {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    color: black;\r\n    height: 60px;\r\n  }\r\n  .awardlist_star_description {\r\n    margin: 0;\r\n    padding: 8px 0px;\r\n    font-weight: 500;\r\n    font-size: 2vh;\r\n    line-height: 1.2;\r\n  }\r\n  .awardlist_star_icon {\r\n    width: 18%;\r\n    margin: 0 10px;\r\n  }\r\n  .award_list_two_img {\r\n    filter: brightness(65%);\r\n    border-radius: 1px;\r\n    border: 1px solid white;\r\n    overflow: hidden;\r\n    object-fit: contain;\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n  .award_list_two_mob_container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 100%;\r\n  }\r\n  .hide_about_page_in_mobile {\r\n    display: none !important;\r\n  }\r\n\r\n  .team_members_details {\r\n    background-color: transparent;\r\n    border-color: #ffb037;\r\n    border-radius: 10px;\r\n    display: flex;\r\n    margin: 2vh;\r\n  }\r\n  .team_member_image {\r\n    display: flex;\r\n  }\r\n  .team_members_details .team_member_image {\r\n    flex-direction: column-reverse;\r\n  }\r\n  .team_members_details .team_member_name {\r\n    width: 100%;\r\n  }\r\n  .team_members_details .member_description {\r\n    margin-top: 20px;\r\n  }\r\n  .member_description {\r\n    width: 100%;\r\n  }\r\n  .policy-container h1 {\r\n    font-size: 1.2em;\r\n  }\r\n\r\n  .policy-container p,\r\n  .policy-container li {\r\n    font-size: 0.9em;\r\n  }\r\n  .corrections-policy {\r\n    padding: 10px;\r\n  }\r\n\r\n  .corrections-policy h1 {\r\n    font-size: 1.2em;\r\n  }\r\n\r\n  .corrections-policy p {\r\n    font-size: 0.8em;\r\n  }\r\n\r\n  .corrections-policy li {\r\n    font-size: 0.8em;\r\n  }\r\n  .ifcn_main_container {\r\n    width: 100%;\r\n  }\r\n  .fact_check_container {\r\n    gap: 0px;\r\n  }\r\n  .ifcn_certificates_notes{\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 3px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
